class CartCrossSell extends HTMLElement {
  removalTimeouts = new Set();

  connectedCallback() {
    if (this.hasAttribute('data-remove-added-products')) {
      document.addEventListener('cart:update', this.handleCartUpdate);
    }
  }

  disconnectedCallback() {
    document.removeEventListener('cart:update', this.handleCartUpdate);
    this.removalTimeouts.forEach((timeoutId) => clearTimeout(timeoutId));
    this.removalTimeouts.clear();
  }

  handleCartUpdate = (event) => {
    if (event.detail?.data?.didError || event.detail?.data?.source !== 'product-form-component') return;

    const productId = event.detail?.data?.productId;
    if (!productId) return;

    const product = this.querySelector(`[data-cross-sell-product-id="${CSS.escape(String(productId))}"]`);
    if (!product || product.classList.contains('cart-cross-sell__product--added')) return;

    const button = product.querySelector('.cart-cross-sell__add-button');
    const addLabel = button?.querySelector('[data-cross-sell-add-label]');
    const addedLabel = button?.querySelector('[data-cross-sell-added-label]');

    if (button) {
      button.disabled = true;
      button.classList.add('cart-cross-sell__add-button--added');
    }

    if (addLabel instanceof HTMLElement) addLabel.hidden = true;
    if (addedLabel instanceof HTMLElement) addedLabel.hidden = false;
    product.classList.add('cart-cross-sell__product--added');

    const successTimeoutId = setTimeout(() => {
      this.removalTimeouts.delete(successTimeoutId);
      if (!product.isConnected) return;

      product.classList.add('cart-cross-sell__product--removing');

      const removalTimeoutId = setTimeout(() => {
        this.removalTimeouts.delete(removalTimeoutId);
        this.removeProduct(product);
      }, 200);

      this.removalTimeouts.add(removalTimeoutId);
    }, 2000);

    this.removalTimeouts.add(successTimeoutId);
  };

  removeProduct(product) {
    const slider = this.querySelector('media-slider');

    if (slider?.swiper) {
      const slideIndex = Array.from(slider.swiper.slides).indexOf(product);

      if (slideIndex >= 0) {
        slider.swiper.removeSlide(slideIndex);
      } else {
        product.remove();
        slider.swiper.update();
      }
    } else {
      product.remove();
    }

    if (!this.querySelector('[data-cross-sell-product-id]')) {
      this.remove();
    }
  }
}

if (!customElements.get('cart-cross-sell')) {
  customElements.define('cart-cross-sell', CartCrossSell);
}
